import * as Sentry from '@sentry/react';

export type MtmPayload = Record<string, unknown>;

export const pushToMtm = (obj: MtmPayload): void => {
  const _mtm = (window._mtm = window._mtm || []);
  try {
    _mtm.push(obj);
  } catch (error) {
    Sentry.captureException(error, {
      level: 'warning',
      tags: { type: 'mtm' },
      extra: { mtmEvent: obj?.['event'] ?? obj?.['action'] },
    });
  }
};
